import { createStandardAction } from 'typesafe-actions';
import { WritingInterval } from '../../../Models';

export const savePageEditorEditablePage = createStandardAction('@@editor/SAVE_EDITABLE_PAGE')();
export const cancelPageEditorEdit = createStandardAction('@@editor/CANCEL_PAGE_EDIT')();

export const resetPageEditorState = createStandardAction('@@editor/RESET_STATE')();

export const setPageEditorEditablePage = createStandardAction('@@editor/SET_EDITABLE_PAGE')<any>();
export const setPageEditorEditablePageById = createStandardAction('@@editor/SET_EDITABLE_PAGE_BY_ID')<string>();

interface PageUpdate {
  text: string;
  writingIntervals: WritingInterval[];
}

export const updatePageEditorEditablePage = createStandardAction('@@editor/UPDATE_EDITABLE_PAGE')<PageUpdate>();

export const startPageEditorSaga = createStandardAction('@@editor/START_SAGA')();
export const cancelPageEditorSaga = createStandardAction('@@editor/CANCEL_SAGA')();

export const storePageEditorSate = createStandardAction('@@editor/STORE_STATE')();
export const loadPageEditorSate = createStandardAction('@@editor/LOAD_STATE')();
export const loadPageEditorSateError = createStandardAction('@@editor/LOAD_STATE_ERROR')<any>();

export const updatePageEditorStateFromExternalSource = createStandardAction(
  '@@editor/UPDATE_STATE_FROM_EXTERNAL_SOURCE',
)<any>();

export const updatePageEditorFirstVisitState = createStandardAction('@@editor/UPDATE_FIRST_VISIT_STATE')<boolean>();



// WEBPACK FOOTER //
// ./src/containers/PagesHistory/PageEditor/actions.ts